export default "__VITE_ASSET__LPRteTzk__"